import { useState } from 'react'
import { Chart } from 'react-google-charts'

import {
  Row,
  ChartContainer,
  LegendContainer,
  LegendItem,
  LegendLabel,
  ColorBox
} from '../styles'

export default function ColumnChart ({
  data,
  options = {},
  legendPosition = 'right',
  ...props
}) {
  const [visibleSeries, setVisibleSeries] = useState (data[0].slice (1).map (() => true))

  const handleLegendClick = idx => {
    setVisibleSeries (series => {
      const visibleCount = series.filter (Boolean).length

      if (visibleCount === 1 && series[idx]) return series

      const newSeries = [...series]
      newSeries[idx] = !newSeries[idx]
      return newSeries
    })
  }

  const filteredData = [
    [data[0][0], ...data[0].slice (1).filter ((_, idx) => visibleSeries[idx])],
    ...data.slice (1).map (row => [row[0], ...row.slice (1).filter ((_, idx) => visibleSeries[idx])])
  ]

  const chartOptions = {
    isStacked: true,
    backgroundColor: 'transparent',
    height: 500,
    fontName: 'Segoe UI',
    legend: 'none',
    hAxis: {
      title: 'Mês / ano',
      titleTextStyle: {
        bold: true
      }
    },
    vAxis: {
      title: 'Faturamento (R$)',
      titleTextStyle: {
        bold: true
      }
    },
    chartArea: {
      width: '100%',
      left: 110
    },
    colors: [
      '#FFC100', '#44CF6C', '#43D4CB', '#35A7FF', '#474AFD', '#B553DB', '#D164B8',
      '#FF3939', '#FF9939', '#96D35D', '#35FFBC', '#9335ff', '#FF65EA', '#FFC100',
      '#44CF6C', '#43D4CB', '#35A7FF', '#474AFD', '#B553DB', '#D164B8', '#FF3939',
      '#FF9939', '#96D35D', '#35FFBC', '#9335ff', '#FF65EA'
    ],
    tooltip: {
      textStyle: {
        fontSize: 14
      }
    },
    ...options
  }
  
  const filteredColors = chartOptions.colors.filter ((_, idx) => visibleSeries[idx])
  const labels = data[0].slice (1)

  const renderLegend = () => (
    <LegendContainer style={{
      alignSelf: legendPosition === 'top' ? 'flex-end' : 'center',
      marginTop: legendPosition === 'top' ? 10 : 0,
      marginRight: legendPosition === 'top' ? 35 : 25,
    }}>
      {labels.map ((label, idx) => (
        <LegendItem
          key={idx}
          onClick={() => handleLegendClick (idx)}
          style={{ opacity: visibleSeries[idx] ? 1 : 0.4, cursor: 'pointer' }}
        >
          <ColorBox color={chartOptions.colors[idx]}/>
          <LegendLabel>{label}</LegendLabel>
        </LegendItem>
      ))}
    </LegendContainer>
  )

  return (
    <Row>
      <ChartContainer>
        {legendPosition === 'top' && renderLegend ()}
        <Chart
          chartType='ColumnChart'
          width='100%'
          data={filteredData}
          options={{ ...chartOptions, colors: filteredColors }}
          {...props}
        />
      </ChartContainer>
      {legendPosition === 'right' && renderLegend ()}
    </Row>
  )
}
